<template>
  <section class="may-flash-sale">
    <div class="may-flash-sale__content">
      <h1 class="may-flash-sale__title">
        Save 50% on INE Certifications + Training Bundles and Certifications
      </h1>
      <div class="may-flash-sale__intro-wrapper">
        <div class="may-flash-sale__description">
          <p>
            Accelerate your journey in Cybersecurity, Networking, and Cloud with exclusive savings
            on Certification + Training bundles and INE Security Certifications.
          </p>
        </div>
        <div class="may-flash-sale__links-wrapper">
          <a
            class="btn btn--primary btn--full-mobile"
            href="https://learn.ine.com/promo/flash-sale-certs-training"
            target="_blank"
            rel="noopener noreferrer"
          >
            Save Now
          </a>
        </div>
      </div>
    </div>
    <div class="may-flash-sale__icon">
      <div class="may-flash-sale__icon-logo-wrapper">
        <img
          :src="MayFlashSaleLogo"
          alt="may-flash-sale Savings Promo"
          class="may-flash-sale__icon-logo"
        />
      </div>
    </div>
  </section>
</template>

<script>
import MayFlashSaleLogoPng from '@/assets/images/hero-section/may-flash-sale/mfs-logo.png'

export default {
  name: 'MayFlashSaleHeroSection',
  computed: {
    MayFlashSaleLogo() {
      return MayFlashSaleLogoPng
    },
  },
}
</script>

<style lang="scss" scoped>
.may-flash-sale {
  width: 100%;
  max-width: 1120px;
  color: var(--white);
  font-family: var(--font-regular);
  display: flex;
  flex-flow: column-reverse;
  align-items: center;
  position: relative;
  padding: 0 20px 20px 20px;
  @include mobile {
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
  }
  @include tablet {
    margin: 0 auto;
    padding: 0;
    gap: 0;
  }
  @include desktop {
    flex-flow: row;
    margin: auto;
    padding: 10px 0 100px 0;
    gap: 0;
  }
  &__title {
    font-family: var(--font-medium);
    color: var(--white);
    font-size: rem(26px);
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    margin: 0;
    @include mobile {
      font-family: var(--font-medium);
      font-size: rem(30px);
      font-weight: 900;
      line-height: normal;
    }
    @include desktop {
      font-family: var(--font-regular);
      font-size: rem(44px);
      font-weight: 700;
      line-height: normal;
    }
  }
  &__intro {
    font-size: rem(17px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(26px);
    @include desktop {
      font-size: rem(24px);
      line-height: rem(32px);
    }
  }
  &__description {
    p {
      margin: 0 0 10px 0;
    }
    color: var(--light-blue-gray);
    font-size: rem(17px);
    font-style: normal;
    font-weight: 450;
    line-height: 24px;
    width: 100%;

    &-highlight {
      color: var(--white);
      font-weight: 700;
    }
    &-couponflash {
      color: #88ebfe;
      font-weight: 700;
    }
    &-couponbundle {
      color: #fb99b3;
      font-weight: 700;
    }

    @include mobile {
      width: 100%;
    }
    @include desktop {
      width: 100%;
      font-size: rem(24px);
      line-height: 32px;
    }
  }
  &__links-wrapper {
    display: flex;
    gap: 10px;
    flex-direction: column;
    margin-top: 30px;
    > * {
      @include mobile {
        height: 36px;
        font-size: 14px;
      }
      @include tablet {
        height: 36px;
        font-size: 16px;
      }
      @include desktop {
        height: 47px;
      }
    }

    @include tablet {
      flex-direction: row;
    }
  }

  &__content {
    display: flex;
    flex-flow: column;
    gap: 20px;
    margin-top: 0;
    @include mobile {
      margin-top: 40px;
    }

    @include tablet {
      margin-top: 50px;
    }
  }
  &__icon {
    position: relative;

    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    &-logo {
      width: 100%;
    }
    &-logo-wrapper {
      margin: 0;
      margin-left: -52px;
      display: flex;
      justify-content: center;
      position: inherit;
      @include mobile {
        margin-left: 0;
        width: 387px;
        position: absolute;
      }
      @include tablet {
        width: 356px;
      }
      @include desktop {
        margin-top: -60px;
        width: 614px;
      }
    }
  }
}
</style>
